/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.componentId, _vm._g(_vm._b({
    tag: "component",
    scopedSlots: _vm._u([_vm._l(Object.keys(_vm.$slots), function (slotName) {
      return {
        key: slotName,
        fn: function () {
          return [_vm._t(slotName)];
        },
        proxy: true
      };
    })], null, true)
  }, 'component', _vm.$attrs, false), _vm.$listeners));
};
var staticRenderFns = [];
export { render, staticRenderFns };